import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/** 경로 비교용 정규화 (MenuFilter 와 동일 기준) */
const normalize = (s: string) => s.trim().replace(/\/+$/, "").toLowerCase();

/**
 * 현재 라우트에 대한 isWrite === 'Y' 여부.
 * 권한 데이터가 없거나 매칭 권한의 isWrite 가 Y 가 아니면 false.
 */
export function useCanWrite(): boolean {
  const { roles } = useAuth();
  const { pathname } = useLocation();

  const perm = roles.find(
    (r) => r?.apiUrl && normalize(r.apiUrl) === normalize(pathname),
  );

  return perm?.isWrite === "Y";
}
